import { motion } from 'motion/react';

interface TourOverlayProps {
  targetRect: DOMRect | null;
  onClose: () => void;
  /** Paso de acción (X3): la pantalla sigue usable debajo y un clic no cierra el recorrido. */
  dejaPasar?: boolean;
}

const PADDING = 8;

export function TourOverlay({ targetRect, onClose, dejaPasar = false }: TourOverlayProps) {
  // Build clip-path polygon that creates a "hole" around the target
  const clipPath = targetRect ? buildClipPath(targetRect) : undefined;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.25 }}
      className="fixed inset-0 z-[9998]"
      data-testid="tour-overlay"
      style={dejaPasar ? { pointerEvents: 'none' } : undefined}
      onClick={dejaPasar ? undefined : onClose}
    >
      <div
        className="absolute inset-0 bg-black/60 transition-[clip-path] duration-300 ease-out"
        style={{ clipPath }}
      />
    </motion.div>
  );
}

function buildClipPath(rect: DOMRect): string {
  const top = Math.max(0, rect.top - PADDING);
  const left = Math.max(0, rect.left - PADDING);
  const bottom = rect.bottom + PADDING;
  const right = rect.right + PADDING;

  // Outer rectangle (full screen) with inner rectangle cutout
  // Using polygon with 8 points to create the hole
  return `polygon(
    0% 0%, 0% 100%,
    ${left}px 100%, ${left}px ${top}px,
    ${right}px ${top}px, ${right}px ${bottom}px,
    ${left}px ${bottom}px, ${left}px 100%,
    100% 100%, 100% 0%
  )`;
}
